import { useRef, useState } from 'react';
import { StatusCodes, getReasonPhrase } from "http-status-codes";
import { config } from "../../constants";
import apiClient from '../../utils/apiClient';
import { Form, Modal, Row, Button as ButtonBootstrap } from 'react-bootstrap';
import CircleSign from './CircleSign';
import { ToastContainer, toast } from "react-toastify";

const url = config.url.URL;

const RequestAssistance = ({openCloseRequestAssistanceModal, successed, showRequestAssistanceModal}) => {

    const Email = useRef();
    const Msg = useRef();

    const [emailEmpty, setEmailEmpty] = useState(false);
    const [emailValid, setEmailValid] = useState(true);
    const [msgEmpty, setMsgEmpty] = useState(false);
    const [msgVal, setMsgVal] = useState(true);

    const saveRequest = async () => { 
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const isEmailEmpty = Email.current.value.trim() === "";
      const isEmailValid = emailRegex.test(Email.current.value.trim());
      const isMsgEmpty = Msg.current.value.trim() === "";
      const isMsgValid = Msg.current.value.trim().length > 20;
      
      setEmailEmpty(isEmailEmpty);
      setEmailValid(isEmailValid);
      setMsgEmpty(isMsgEmpty);
      setMsgVal(isMsgValid);

      if (isEmailEmpty || isMsgEmpty || !isEmailValid || !isMsgValid) {
        return;
      }
    
      const requestData = {
        email: Email.current.value,
        message: Msg.current.value
      };
    
      try {
        const response = await apiClient.post(`${url}/login/Sendemail`, requestData);
        if (response.status === StatusCodes.OK) {
          toast.success("Your request for assistance has been registered, you will be contacted soon by your support");
          successed();
        } else {
          toast.error("Your request for assistance could not be registered, please try again. In case of new failure, please contact your support.");
        }
      } catch (error) {
        toast.error("Your request for assistance could not be registered, please try again. In case of new failure, please contact your support.");
      }
    };
    

  return (
    <Modal
    show={showRequestAssistanceModal}
    onHide={openCloseRequestAssistanceModal}
    size="md"
  >
    <Modal.Header closeButton>
      <Modal.Title size="h6">Request for assistance</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Row>
        <Form.Group className="mb-3 col-md-12" controlId="Email">
          <Form.Label className={`${(!emailEmpty && emailValid) ? "normal-title" : "validation-title"} margin-bot-1`}>Email <CircleSign /></Form.Label>
          <Form.Control
          className={`${(emailEmpty || !emailValid) && "validation-control"}`}
          type="text" ref={Email} placeholder="Email" />
          {emailEmpty && <p className="p-required" style={{marginBottom:'0'}}>Required</p>}
          {!emailEmpty && !emailValid && <p className="p-required">Please enter a valid email address.</p>}
        </Form.Group>
      </Row>
      <Row>
        <Form.Group className="mb-3 col-md-12" controlId="Msg">
          <Form.Label className={`${msgVal ? "normal-title" : "validation-title"} margin-bot-1`}>
            Please enter your message <CircleSign />
          </Form.Label>
          <Form.Control
          className={`${!msgVal && "validation-control"}`}
            type="text"
            ref={Msg}
            placeholder="Please enter your message"
          />
          {msgEmpty && <p className="p-required" style={{marginBottom:'0'}}>Required</p>}
          {!msgEmpty && !msgVal && <p className="p-required" style={{marginBottom:'0'}}>Please enter a valid message (more than 20 characters)</p>}
          {!msgVal && <p className="p-required">Mandatory fields are missing or invalid. Your request cannot be submitted.</p>}
        </Form.Group>
      </Row>
    </Modal.Body>
    <Modal.Footer>
      <ButtonBootstrap
        variant="primary"
        className="btnPrimary"
        onClick={saveRequest}
      >
        Submit
      </ButtonBootstrap>
      <ButtonBootstrap
        variant="secondary"
        className="btnSecondary"
        onClick={openCloseRequestAssistanceModal}
      >
        Cancel
      </ButtonBootstrap>
    </Modal.Footer>
  </Modal>
  )
}

export default RequestAssistance